import { authEnabled, signOut } from '../lib/auth.js'

// Who the API thinks you are, and the way out.
//
// The name comes from /api/me rather than from the token the browser already
// holds, because that is the identity written to `created_by`. With auth off it
// says so in as many words: every write on that deployment is attributed to one
// shared address, and a line on screen is harder to miss than a startup warning.
export default function Identity({ me }) {
  if (!me) return null

  const label = me.name || me.email || 'Signed in'
  const initials = (me.name || me.email || '?')
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()

  return (
    <div className="sb-user">
      <div className="sb-user-badge" aria-hidden="true">
        {initials}
      </div>
      <div className="sb-user-who">
        <div className="sb-user-name" title={me.email}>
          {label}
        </div>
        <div className="sb-user-mail" title={me.email}>
          {me.authenticated ? me.email : 'Not signed in — shared identity'}
        </div>
      </div>
      {authEnabled ? (
        <button type="button" className="sb-user-out" onClick={signOut} title="Sign out">
          Sign out
        </button>
      ) : null}
    </div>
  )
}
